export default __webpack_public_path__ + "static/media/IMG-20241210-WA0042.59fa5081.jpg";